// extracted by mini-css-extract-plugin
export default {"icon6":"ToTop_icon6__qPrQ3","groupChild5":"ToTop_groupChild5__qudP1"};